import site from '@/config/site';
import RouterView from '@/views/common-view/index.vue';
import common from '@cloudpivot/common/pc';
// import list from '@cloudpivot/list/pc';
import applicationRoutes from './applicationRoutes';
export default {
    home: {
        path: '/',
        redirect: {
            name: 'workbenchCenter'
        }
    },
    externalLink: {
        path: '/external-link/:formid',
        name: 'external-link',
        meta: { title: ' ' },
        component: () => import('@/views/external-link.vue')
    },
    // empty: {
    //   path: '/empty',
    //   name: 'empty',
    //   component: () => import('@/components/global/empty.vue')
    // },
    error: {
        path: '/error',
        name: 'error',
        component: () => import('@/views/shared/error.vue')
    },
    permission: {
        path: '/permission',
        name: 'permission',
        component: () => import('@/views/shared/permission/permission.vue')
    },
    formUnpublished: {
        path: '/form-unpublished',
        name: 'formUnpublished',
        component: common.components.FormUnpublished
    },
    oauth: {
        path: '/oauth',
        name: 'oauth',
        component: () => import('@/views/oauth/oauth.vue')
    },
    print: {
        path: '/print',
        name: 'print',
        meta: { title: site.title },
        component: () => import('@/views/applications/print.vue')
    },
    login: {
        path: '/login',
        name: 'login',
        meta: { title: site.title },
        // component: () => import('@/views/login/login.vue')
        component: () => import('@/views/login/login-new.vue')
    },
    loginError: {
        path: '/login-error',
        name: 'loginError',
        meta: { title: site.title },
        component: () => import('@/views/loginError/index.vue')
    },
    formDetail: {
        path: '/form/detail',
        name: 'form-detail',
        component: () => import(/* webpackChunkName: "form-detail" */ '@/views/form/form-detail.vue')
    },
    // flowTrackLogs: {
    //   path: '/from/workflow-track/:workflowInstanceId/operation-logs/',
    //   name: 'flowTrackOperationLogs',
    //   meta: { title: site.title + '-操作日志' },
    //   component: flow.components.OperationLogs
    // },
    flowTrack: {
        path: '/from/workflow-track/:workflowInstanceId/:workItemId/',
        name: 'flowTrack',
        meta: { title: site.title + '-flow track' },
        component: () => import('@/views/form/workflow-track/workflow-track.vue')
    },
    operationLogsCompare: {
        path: '/from/operation-log-compare/:logid',
        name: 'operationLogsCompare',
        component: () => import('@/views/form/workflow-track/operation-log-compare.vue')
    },
    sharedSuccess: {
        path: '/shared/success',
        name: 'shared-success',
        component: () => import('@/views/shared/success.vue')
    },
    sharedEmpty: {
        path: '/shared/empty',
        name: 'shared-empty',
        component: () => import('@/views/shared/empty.vue')
    },
    workbench: {
        root: {
            path: '/workbench-center',
            name: 'workbenchCenter',
            meta: { title: site.title + '-workbench' },
            component: () => import('@/views/workflow-center/workbenchInfo/workbenchView.vue'),
            redirect: { name: 'workbench' },
        },
        workbench: {
            path: 'workbench',
            name: 'workbench',
            meta: { title: site.title + '-workbench' },
            component: () => import('@/views/workflow-center/workbenchInfo/workbench.vue'),
            selectedKeys: 'workbench'
        },
        draftList: {
            path: 'draft-list',
            name: 'draftList',
            meta: { title: site.title + '-draft' },
            component: () => import('@/views/workflow-center/workbenchInfo/draftList.vue'),
        },
        messageNotification: {
            path: 'message-notification',
            name: 'messageNotification',
            meta: { title: site.title + '-message' },
            component: () => import('@/views/workflow-center/workbenchInfo/messageNotification.vue'),
        },
    },
    // 应用门户
    applicationPortal: {
        root: {
            path: '/application-portal',
            name: 'applicationPortal',
            meta: { title: site.title + '-portal' },
            component: () => import('@/views/workflow-center/workbenchInfo/workbenchView.vue'),
            redirect: { name: 'portal' },
        },
        workbench: {
            path: 'portal',
            name: 'portal',
            meta: { title: site.title + '-portal' },
            component: () => import('@/views/applicationPortal/application-portal.vue'),
            selectedKeys: 'applicationPortal'
        },
    },
    application: {
        root: {
            path: '/',
            name: 'applicationCenterRoot',
            component: () => import('@/views/workflow-center/workbenchInfo/workbenchView.vue'),
            redirect: { name: 'application' },
        },
        application: Object.assign({}, applicationRoutes.infoPath, { 
            // redirect: { name: 'applicationList' },
            children: [
                ...applicationRoutes.infoChildren
                // {
                //   path: 'application-list/:schemaCode',
                //   name: 'applicationList',
                //   component: list.components.ApplicationList
                // },
                // {
                //   path: 'application-define/:url',
                //   name: 'applicationDefine',
                //   component: () => import('@/views/applications/application-define.vue'),
                // },
                // {
                //   path: 'application-report/:reportCode',
                //   name: 'applicationReport',
                //   component: () => import('@/views/applications/report.vue')
                // },
                // {
                //   path: 'application-custom',
                //   name: 'custom',
                //   component: () => import('@/views/applications/custom-router-page/test.vue')
                // }
            ] })
    },
    workflowCenter: {
        // root: {
        //   path: '/workflow-center',
        //   name: 'workflowCenter',
        //   component: RouterView,
        //   redirect: { name: 'myUnfinishedWorkItem' },
        // },
        root: {
            path: '/',
            name: 'workflowCenterRoot',
            component: () => import('@/views/workflow-center/workbenchInfo/workbenchView.vue'),
            redirect: { name: 'workflowCenter' },
        },
        workflowCenter: {
            path: '/workflow-center',
            name: 'workflowCenter',
            component: RouterView,
            redirect: { name: 'myUnfinishedWorkItem' },
            children: [
                {
                    path: 'my-unfinished-workitem',
                    name: 'myUnfinishedWorkItem',
                    meta: { title: site.title + '-my tasks' },
                    component: () => import('@/views/workflow-center/myUnfinishedWorkItem.vue')
                },
                {
                    path: 'start-workflow',
                    name: 'startWorkflow',
                    meta: { title: site.title + '-startworkflow' },
                    component: () => import('@/views/workflow-center/start-workflow.vue')
                },
                // {
                //   path: 'my-unread-workitem',
                //   name: 'myUnReadWorkItem',
                //   meta: { title: site.title + '-我的待阅' },
                //   component: () => import('@/views/workflow-center/myUnReadWorkItem.vue')
                // },
                {
                    path: 'my-finished-workitem',
                    name: 'myFinishedWorkItem',
                    meta: { title: site.title + '-my finished' },
                    component: () => import('@/views/workflow-center/myFinishedWorkitem.vue')
                },
                // {
                //   path: 'my-read-workitem',
                //   name: 'myReadWorkItem',
                //   meta: { title: site.title + '-我的已阅' },
                //   component: () => import('@/views/workflow-center/myReadWorkItem.vue')
                // },
                {
                    path: 'my-workflow',
                    name: 'myWorkflow',
                    meta: { title: site.title + '-my running' },
                    component: () => import('@/views/workflow-center/my-workflow.vue')
                },
                {
                    path: 'delegation-workflow',
                    name: 'delegationWorkflow',
                    meta: { title: site.title + '-delegation' },
                    component: () => import('@/views/workflow-center/delegation-workflow.vue')
                },
                {
                    path: 'query-instance',
                    name: 'queryInstance',
                    meta: { title: site.title + '-query instance' },
                    component: () => import('@/views/workflow-center/query-instance.vue')
                },
                {
                    path: 'query-participant-workItem',
                    name: 'queryParticipantWorkItem',
                    meta: { title: site.title + '-query participant' },
                    component: () => import('@/views/workflow-center/task-search.vue')
                },
                // 二开 新增路由
                {
                    path: 'delegation-report',
                    name: 'delegationReport',
                    meta: { title: site.title + '-delegation' },
                    component: () => import('../../extends/views/DelegationReport/delegationReport.vue')
                },
                {
                    path: 'delegationToMe',
                    name: 'delegationToMe',
                    meta: { title: site.title + '-delegation' },
                    component: () => import('../../extends/views/DelegationToMe/delegationToMe.vue')
                },
            ]
        },
    },
    user: {
        root: {
            path: '/user',
            name: 'user',
            component: RouterView,
            redirect: { name: 'info' },
        },
        info: {
            path: '/',
            name: 'info',
            meta: { title: site.title + '-个人信息' },
            component: () => import('@/views/user-info/user-info.vue')
        }
    },
    singleApp: {
        root: {
            path: '/singleApp/:appCode',
            name: 'singleApp',
            component: () => import('@/views/single-app/index.vue'),
            redirect: '/app-home',
        },
        appHome: {
            path: '/app-home',
            name: 'appHome',
            component: () => import('@/views/single-app/home.vue'),
        },
        appList: {
            path: '/app-list/:appCode/:schemaCode/:displayName',
            name: 'appList',
            component: () => import('@/views/single-app/list.vue'),
        },
        appToDo: {
            path: '/app-todo',
            name: 'appToDo',
            component: () => import('@/views/single-app/todo.vue'),
        },
        appToRead: {
            path: '/app-toread',
            name: 'appToRead',
            component: () => import('@/views/single-app/toread.vue'),
        },
        appDone: {
            path: '/app-done',
            name: 'appDone',
            component: () => import('@/views/single-app/done.vue'),
        },
        appReaded: {
            path: '/app-readed',
            name: 'appReaded',
            component: () => import('@/views/single-app/readed.vue'),
        },
        appReport: {
            path: '/app-report/:appCode/:reportCode',
            name: 'appReport',
            component: () => import('@/views/applications/report.vue')
        },
        appDefine: {
            path: '/app-define/:url',
            name: 'appDefine',
            component: () => import('@/views/applications/application-define.vue')
        }
    }
};
